import React from 'react';


const boxes = [
    [['vehicule'],'Votre véhicule'],
    [['vous'],'Vous'],
    [['antecedents'],'Vos antécédents'],
    [['landing'],'Choix de la formule'],
    [['details1'],'Confirmation'],
    [['payment'],'Paiement'],
    [['subscribing','subscribe_error','presubscribe_error','cancelled'],'Souscription']
]

const boxesAxa = [
    [['vehicule'],'Votre véhicule'],
    [['vous'],'Vous'],
    [['antecedents'],'Vos antécédents'],
    [['landing'],'Choix de la formule'],
    [['details2'],'Confirmation'],
    [['payment2'],'Paiement'],
    [['subscribing2','subscribe_error2','presubscribe_error2','cancelled'],'Souscription']
]


const boxesFma = [
    [['vehicule'],'Votre véhicule'],
    [['vous'],'Vous'],
    [['antecedents'],'Vos antécédents'],
    [['landing'],'Choix de la formule'],
    [['details3'],'Confirmation'],
    [['payment3'],'Paiement'],
    [['paid_subscribed3'],'Signature des documents'],
]


const processBoxes = [
    [['details1'],'Confirmation'],
    [['payment'],'Paiement'],
    [['subscribing','subscribe_error','presubscribe_error','cancelled'],'Souscription'],
    [['paid_subscribed'],'Souscription validée']
]


const processBoxesAxa = [
    [['details2'],'Confirmation'],
    [['payment2'],'Paiement'],
    [['subscribing2','subscribe_error2','presubscribe_error2','cancelled'],'Souscription'],
    [['paid_subscribed2'],'Souscription validée']
]


const processBoxesFma = [
    [['details3'],'Confirmation'],
    [['subscribing3','subscribe_error3','cancelled'],'Souscription'],
    [['paid_subscribed3'],'Souscription validée']
]

const processPages = ['subscribing','subscribe_error','presubscribe_error','cancelled','paid_subscribed']
const processPagesAxa = ['subscribing2','subscribe_error2','presubscribe_error2','cancelled','paid_subscribed2']
const processPagesFma = ['subscribing3','subscribe_error3','cancelled','paid_subscribed3']


class FrontProgressBox extends React.Component {
    constructor(props) {
        super(props)
    }

    onClick() {
        if ( this.props.future < 0 ) {
            this.props.setPage(this.props.toPage)
        } else if (( this.props.future >= 1 )&&( this.props.toPage != 'subscribing' )) {
            if ( this.props.onSubmit ) this.props.onSubmit()
        }
    }

    render() {
        if ( this.props.selected ) return <div className="progress_box selected">{this.props.title}</div>
        if ( this.props.future > 0 ) return <div className="progress_box future" onClick={this.onClick.bind(this)}>{this.props.title}</div>
        return <div className="progress_box" onClick={this.onClick.bind(this)}>{this.props.title}</div>
    }
}

export default class FrontProgress extends React.Component {

    constructor(props) {
        super(props);
    }

    renderBoxes(list) {
        let future = -1
        return list.map( entry => {
            const [pages,title] = entry
            const selected = pages.includes(this.props.page)
            if ( selected ) future = 0
            else {
                if ( future >= 0 ) future += 1
            }
            return <FrontProgressBox onSubmit={this.props.onSubmit} key={pages} toPage={pages[0]} title={title} selected={selected} future={future} setPage={this.props.setPage}/>
        })
    }

    showBoxes() {
        const {page} = this.props
        switch ( this.props.lastBranch ) {
            case 'axa':
                if ( processPagesAxa.includes(page) ) return processBoxesAxa
                return boxesAxa
            case 'fma':
                if ( processPagesFma.includes(page) ) return processBoxesFma
                return boxesFma

            default:
                if ( processPages.includes(page) ) return processBoxes
                return boxes;
        }
    }

    render() {
        return <div className="titlebox" ref={this.props.topRef}>
            {this.renderBoxes(this.showBoxes())}
        </div>
    }
}
